<template>
  <div class="vd-gl-content">
    <a-row type="flex" class="vd-toolbar">
      <a-col flex="auto" class="vd-toolbar-left vd-bar" />
    </a-row>
    <a-table
      size="small"
      row-key="id"
      :pagination="pagination"
      :data-source="dataList"
    >
      <a-table-column title="id" data-index="id" />
      <a-table-column title="素材名" data-index="name" />
      <a-table-column title="类型" data-index="tag">
        <template slot-scope="text">
          <template v-for="item in text">
            <a-tag style="margin-bottom: 4px" :key="item.id" color="#2db7f5">
              {{ item.name }}</a-tag
            >
          </template>
        </template>
      </a-table-column>
      <a-table-column
        title="内容"
        align="center"
        :width="350"
        data-index="content"
      >
        <template slot-scope="text">
          <div v-html="text"></div>
        </template>
      </a-table-column>
      <a-table-column title="点击量" data-index="point_count" />
      <a-table-column title="收藏量" data-index="fav_count" />
      <a-table-column title="操作">
        <template slot-scope="record">
          <a-tag color="blue">修改 {{ record.id }}</a-tag>
        </template>
      </a-table-column>
    </a-table>
  </div>
</template>

<script>
import { materialList, materialTypeList } from '@/api/editor'

export default {
  name: 'type',
  data() {
    return {
      nowScreen: 1,
      type: false,
      visible: false,
      dataList: [],
      typeList: [],
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10,
        onChange: (page) => {
          this.pagination.current = page
          this.getData()
        },
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
    }
  },
  mounted() {
    this.getData()
    // 类型列表
    materialTypeList().then((res) => {
      if (res.code === 1) {
        this.typeList = res.list
      } else {
        this.$message.warning(res.msg)
      }
    })
  },
  methods: {
    getData() {
      materialList({
        current: this.pagination.current,
      }).then((res) => {
        if (res.code === 1) {
          this.dataList = res.list
          this.pagination.total = res.total
        } else {
          this.$message.success(res.msg)
        }
      })
    },

    // 选择屏幕尺寸
    switchScreen(screen) {
      this.nowScreen = screen
    },
  },
}
</script>

<style scoped></style>
